"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationEntity = void 0;
const AppVersionDto_1 = require("../app-versions/AppVersionDto");
const AppVersionEntity_1 = require("../app-versions/AppVersionEntity");
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const LocationDto_1 = require("./LocationDto");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class LocationEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, location) {
        super();
        this._requiredFieldsSetStatus = {
            appVersionId: false,
            name: false
        };
        this._dependencies = dependencies;
        if (location === undefined) {
            this._dto = new LocationDto_1.LocationDto();
        }
        else if (location instanceof LocationDto_1.LocationDto) {
            this._dto = new LocationDto_1.LocationDto(location);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (location instanceof LocationEntity) {
            this._dto = new LocationDto_1.LocationDto(location._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new LocationDto_1.LocationDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getParentLocationId() {
        return this._dto.parentLocationId;
    }
    setParentLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("parentLocationId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("parentLocationId", "Parent Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.parentLocationId) {
            return;
        }
        this._dto.parentLocationId = _untrustedValue;
        this._setIsDirty(true);
    }
    getAppVersion() {
        if (this._dto.appVersionId === undefined) {
            return undefined;
        }
        if (this._dto.appVersion === undefined) {
            throw new Error("Cannot call getAppVersion without first loading the App Version.");
        }
        if (!this._appVersionEntity && this._dto.appVersion) {
            this._appVersionEntity = new AppVersionEntity_1.AppVersionEntity(this._dependencies, this._dto.appVersion);
        }
        return this._appVersionEntity;
    }
    getAppVersionId() {
        return this._dto.appVersionId;
    }
    setAppVersion(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof AppVersionEntity_1.AppVersionEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof AppVersionDto_1.AppVersionDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setAppVersionId(untrustedId);
        if (this.hasError("appVersionId")) {
            return;
        }
        if (untrustedValue instanceof AppVersionEntity_1.AppVersionEntity) {
            this._appVersionEntity = untrustedValue;
        }
    }
    setAppVersionId(untrustedValue) {
        let _untrustedValue;
        this.clearError("appVersionId");
        this._requiredFieldsSetStatus.appVersionId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("appVersionId", "App Version Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("appVersionId", "App Version is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.appVersionId) {
            return;
        }
        this._dto.appVersionId = _untrustedValue;
        delete this._appVersionEntity;
        this._setIsDirty(true);
    }
    getName() {
        return this._dto.name;
    }
    setName(untrustedValue) {
        const maxLength = 60;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("name");
        this._requiredFieldsSetStatus.name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("name", "Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("name", `Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.name) {
            return;
        }
        this._dto.name = _untrustedValue;
        this._setIsDirty(true);
    }
    getMainAddress() {
        return this._dto.mainAddress;
    }
    setMainAddress(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("mainAddress");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("mainAddress", "Main Address is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("mainAddress", `Main Address has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.mainAddress) {
            return;
        }
        this._dto.mainAddress = _untrustedValue;
        this._setIsDirty(true);
    }
    getLatitude() {
        return this._dto.latitude;
    }
    setLatitude(untrustedValue) {
        let _untrustedValue;
        this.clearError("latitude");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("latitude", "Latitude is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.latitude) {
            return;
        }
        this._dto.latitude = _untrustedValue;
        this._setIsDirty(true);
    }
    getLongitude() {
        return this._dto.longitude;
    }
    setLongitude(untrustedValue) {
        let _untrustedValue;
        this.clearError("longitude");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("longitude", "Longitude is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.longitude) {
            return;
        }
        this._dto.longitude = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAppVersionAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getAppVersionId()) {
                    return;
                }
                this._emit("before-loadAppVersionAsync");
                this._dto.appVersion = yield this._dependencies.appVersionDatastore
                    .getAsync(this.getAppVersionId(), expand);
                delete this._appVersionEntity;
                this._emit("after-loadAppVersionAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.locationDatastore
                    .getAsync(id, expand);
                delete this._appVersionEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Location is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.locationDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.locationDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Location cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.locationDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.LocationEntity = LocationEntity;
//# sourceMappingURL=LocationEntity.js.map